export default "__VITE_ASSET__CE7WPcyr__"